export const QUESTION_TYPES = ['favorite', 'scarier', 'cuter', 'technical'] as const;

export const QUESTION_TEXT = {
  favorite: 'Which animatronic do you like more?',
  scarier: 'Which animatronic is scarier?',
  cuter: 'Which animatronic is cuter?',
  technical: 'Which animatronic is more technically impressive?'
} as const;